import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, StyleSheet, Alert, StatusBar, ImageSourcePropType, Linking, Modal, PixelRatio, Platform } from 'react-native'
import Constants from 'expo-constants'
import { Image } from 'expo-image'
import NetInfo from '@react-native-community/netinfo'
import { Feather } from '@expo/vector-icons'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { TouchableOpacity } from 'react-native-gesture-handler'
import * as ImagePicker from 'expo-image-picker'
import { uploadData, getUrl } from 'aws-amplify/storage'
import { getImageStogeUrl, getUrlSave } from '../../imageUploader/ImageStorage'
import theme from '../../../../theme'
import styles from './InputPhotoItemStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { Loader, LoaderImage } from '../../customUtils/Components/Loader'
import { Ionicons } from '@expo/vector-icons'
import { eventEmitter, get_url_save_photo, validateConnectionNetwork } from '../../../utils/functions.utils'
import { getConection } from '../../appBar/context/HeaderContext'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { CameraComponent, resizeIfNecessary } from '../../customUtils/CameraComponent'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import * as NavigationBar from 'expo-navigation-bar'

interface InputPhotoItemProps {
    item: FormContentsModel
    hasCamera: boolean
    hasGalery: boolean
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
}

export const InputPhotoItem = React.memo(({ item, hasCamera, hasGalery, form_id, schedule_id, store_id, checkComplete }: InputPhotoItemProps) => {
    const { languageFile } = getLanguage()
    const [image, setImage] = useState(null)
    const { isConnected, hasInternet } = getConection()
    const placeHolder = require('../../../../assets/placeholderImage.png')
    const [showCameraModal, setShowCameraModal] = useState(false)

    useEffect(() => {
        if (item?.old_response) {
            if (item?.old_response.media) {
                // if (isConnected && hasInternet) {
                const [, newImageUrl] = item?.old_response.media.split('public/')
                getImageStogeUrl(newImageUrl).then((imageUrl) => {
                    setImage(item?.old_response.pickerResult_uri ?? placeHolder)
                })
                // } else {
                //     setImage(placeHolder)
                // }
            } else {
                // setImage(null)
            }
        }
    }, [item?.old_response])

    const handleImagePickerResult = async (photoUri: string) => {
        try {
            eventEmitter.emit('process_start_image')
            if (photoUri) {
                let answer: ModelAnswerFromProps = null
                try {
                    const res_get_url_save_photo = get_url_save_photo('/stores/form')
                    const filename = res_get_url_save_photo
                    let answerScore = '0'
                    if (item.score != null && item.score > 0) answerScore = item.score.toString()
                    answer = {
                        _id: item._id,
                        option_selected_text: [],
                        option_selected_id: [],
                        question_id: item._id,
                        // media: imageUrl,
                        media: '',
                        question_text: item.title,
                        score: answerScore,
                        status: 1,
                        date_finish: new Date().toString(),
                        date_init: new Date().toString(),
                        question_input: '',
                        field_media: '',
                        field_text: '',
                        questionScore: item.questionScore,
                        type: item.input_type.type,
                        ponderar: item.score && item.score > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                        question: item.title,
                        questionOptionSelected: [],
                        questionOptionSelectedText: [],
                        questionType: {
                            title: item.input_type.title,
                            type: item.input_type.type,
                            id: item.input_type._id,
                        },
                        questionPrice: '',
                        description: '',
                        tag: '',
                        questionImage: '',
                        questionInput: '',
                        pickerResult_uri: '', // si se me genera bien la url no hace falta guardar el pick
                    }

                    answer.media = filename
                    answer.questionImage = filename
                    answer.pickerResult_uri = photoUri

                    setImage(placeHolder)
                    const isConnected = await validateConnectionNetwork()
                    if (isConnected) {
                        // const response = await fetch(photoUri)
                        // if (!response.ok) {
                        //     throw new Error('115 Error al subir la imagen')
                        // }
                        // const blob = await response.blob()
                        // const { imageUrl, imageUrlDB } = await getUrlSave(filename, photoUri)
                        // answer.media = imageUrlDB ?? res_get_url_save_photo
                        // answer.questionImage = imageUrlDB ?? res_get_url_save_photo
                        // answer.pickerResult_uri = imageUrlDB ?? res_get_url_save_photo
                        // onPicture(imageUrl)
                        // setImage(imageUrl)
                    } else {
                    }
                    setImage(photoUri)
                } catch (error) {
                    setShowCameraModal(false)
                    console.error('106 Error al subir la imagen:', error)
                    eventEmitter.emit('process_end_image')
                } finally {
                    try {
                        schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
                        await checkComplete(answer)
                    } catch (e) {
                        eventEmitter.emit('process_end_image')
                        Alert.alert('Error', 'No se pudo subir la imagen', e)
                    } finally {
                        setShowCameraModal(false)
                    }

                    // closeBottomSheet(true)
                }
            }
            eventEmitter.emit('process_end_image')
        } catch (error) {
            console.error('167 --- error - handleImagePickerResult: ', error)
        }
    }

    const onPicture = (image: string) => {
        // closeBottomSheet(true)
    }
    const deleteImage = () => {
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [],
            option_selected_id: [],
            question_id: item._id,
            media: null,
            question_text: item.title,
            score: '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [],
            questionOptionSelectedText: [],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: '',
        }

        setImage(null)
        schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
        checkComplete(answer)
    }
    const setSheet = async () => {
        try {
            // let cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
            // let mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()
            // console.log('cameraPermissionResult', cameraPermissionResult, mediaLibraryPermissionResult)
            // if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
            //     Alert.alert(
            //         'Permisos de camara y galería',
            //         'La App requiere permisos para acceder a la cámara y galería',
            //         [
            //             {
            //                 text: 'Cancelar',
            //                 onPress: async () => {},
            //             },
            //             {
            //                 text: 'Configuración',
            //                 onPress: async () => {
            //                     Linking.openSettings()
            //                 },
            //             },
            //         ],
            //         { cancelable: true },
            //     )
            //     return
            // }
            setShowCameraModal(true)
            // openBottomSheet(<PhotoModal hasCamera={hasCamera} hasGalery={hasGalery} handleImagePickerResult={handleImagePickerResult} />, null, true)
        } catch (error) {
            console.error('227 --- : ', error)
        }
    }

    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const openBigImage = () => {
        if (image) {
            openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
        }
    }

    const [iconSize, setIconSize] = useState(12)
    const fontScale = 1
    // Detectar si el tamaño de la fuente ha sido aumentado
    useEffect(() => {
        if (fontScale > 1) {
            setIconSize(16) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(12) // Valor normal
        }
    }, [])

    return (
        <View>
            <Text style={styles.title}>{item.title}</Text>

            {image ? (
                <View style={styles.containerGeneral}>
                    <View style={[styles.subContainer, { flex: 1.2 }]}>
                        <TouchableOpacity onPress={() => openBigImage()}>
                            <Image style={styles.imagePreview} source={image} />
                        </TouchableOpacity>
                        <Text style={[styles.fileName, { flex: 1 }]}>{languageFile.uploaded_image}</Text>
                        <Ionicons name={'checkmark-sharp'} size={iconSize * 1.4} color={theme.colors.colorApproved} />
                    </View>
                    <View style={{ width: 12 }}></View>
                    <View>
                        <TouchableOpacity onPress={() => setSheet()} style={styles.containerMiniButton}>
                            <Text style={styles.textMiniButton}>{languageFile.edit}</Text>
                            <Feather name='edit-2' size={iconSize} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                        <View style={styles.spacer2}></View>
                        <TouchableOpacity onPress={() => deleteImage()} style={styles.containerMiniButtonDelete}>
                            <Text style={styles.textMiniButtonDelete}>{languageFile.delete}</Text>
                            <Feather name='trash-2' size={iconSize} color={theme.colors.error} style={styles.marginLeft} />
                        </TouchableOpacity>
                    </View>
                </View>
            ) : (
                <View style={styles.containerGeneral}>
                    <View style={styles.subContainer}>
                        <Image style={[styles.imagePreview, { width: 80, height: 80 }]} source={placeHolder} />
                        <Text style={styles.fileName}>{languageFile.upload_image}</Text>
                    </View>
                    <View style={{ flex: fontScale > 1 ? 1 : 0.5 }}>
                        <TouchableOpacity onPress={() => setSheet()} style={[styles.containerMiniButton, { justifyContent: 'center' }]}>
                            <Text style={styles.textMiniButton}>{languageFile.photo}</Text>
                            <Feather name='plus-square' size={14} color={theme.colors.colorPrimary} style={styles.marginLeftBis} />
                        </TouchableOpacity>
                    </View>
                </View>

                /*<TouchableOpacity onPress={() => setSheet()}>
                    <View style={styles.floatingButton}>
                        <Text style={styles.floatingButtonText}>AGREGAR FOTO</Text>
                        <Feather name='plus-square' size={16} color={theme.colors.colorPrimary} />
                    </View>
            </TouchableOpacity>*/
            )}
            {showCameraModal && <PhotoModal hasCamera={hasCamera} hasGalery={hasGalery} handleImagePickerResult={handleImagePickerResult} />}
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
})

export const PhotoModal = ({
    hasCamera,
    hasGalery,
    handleImagePickerResult,
}: {
    hasCamera: boolean
    hasGalery: boolean
    handleImagePickerResult: (uri: string) => Promise<void>
}) => {
    const { languageFile } = getLanguage() || {}
    const [loading, setLoading] = useState(false)
    const [isCameraVisible, setIsCameraVisible] = useState(false)
    async function hideAndroidButtons(hide: boolean) {
        if (Platform.OS === 'android') {
            if (hide) {
                NavigationBar.setBehaviorAsync('inset-swipe')
                NavigationBar.setVisibilityAsync('hidden')
            } else {
                NavigationBar.setVisibilityAsync('visible')
                NavigationBar.setBehaviorAsync('inset-touch')
            }
        }
    }
    useEffect(() => {
        const onStart = () => setLoading(true)
        const onEnd = () => setLoading(false)

        eventEmitter.on('process_start_image', onStart)
        eventEmitter.on('process_end_image', onEnd)

        return () => {
            eventEmitter.removeListener('process_start_image', onStart)
            eventEmitter.removeListener('process_end_image', onEnd)
        }
    }, [])

    const options: ImagePicker.ImagePickerOptions = {
        allowsEditing: true,
        quality: 0.3, //1, // la calidad 1 es la mas alta disponible, si  se quiere una calidad baja se puede poner un numero entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
    }

    const closeCamera = () => {
        setIsCameraVisible(false)
    }

    const openCamera = async () => {
        console.log('estoy en la funcion que abre la camara')

        try {
            let cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
            console.log('cameraPermissionResult', cameraPermissionResult)
            if (cameraPermissionResult.granted === false) {
                Alert.alert(
                    'Permisos de camara',
                    'La App requiere permisos para acceder a la cámara',
                    [
                        {
                            text: 'Cancelar',
                            onPress: async () => {},
                        },
                        {
                            text: 'Configuración',
                            onPress: async () => {
                                Linking.openSettings()
                            },
                        },
                    ],
                    { cancelable: true },
                )
                return
            }
            hideAndroidButtons(true)
            setIsCameraVisible(true)
        } catch (error) {
            //setLoading(false)
            eventEmitter.emit('process_end_image')
            console.log('🚀 ~ openCamera ~ error:', error)
        }
    }

    const openGalery = async () => {
        try {
            const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()
            console.log('mediaLibraryPermissionResult', mediaLibraryPermissionResult)
            if (mediaLibraryPermissionResult.granted === false) {
                Alert.alert(
                    'Permisos de galería',
                    'La App requiere permisos para acceder a la galería',
                    [
                        {
                            text: 'Cancelar',
                            onPress: async () => {},
                        },
                        {
                            text: 'Configuración',
                            onPress: async () => {
                                Linking.openSettings()
                            },
                        },
                    ],
                    { cancelable: true },
                )
                return
            }

            const pickerResult = await ImagePicker.launchImageLibraryAsync(options)

            if (!pickerResult.canceled) {
                //setLoading(true)
            }
            let image = pickerResult.assets[0]
            console.log('🚀 ~ openGalery ~ resizedPhoto:', image)

            const resizedPhoto = await resizeIfNecessary(image.uri, image.width, image.height)
            console.log('🚀 ~ openGalery ~ resizedPhoto:', resizedPhoto)
            handleImagePickerResult(resizedPhoto.uri)
        } catch (error) {
            //setLoading(false)
            eventEmitter.emit('process_end_image')
            console.log('🚀 ~ openGalery ~ error:', error)
        }
        // setLoading(false)
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : isCameraVisible ? (
                <View>
                    <Modal visible={true} animationType='slide'>
                        <CameraComponent
                            closeCamera={() => {
                                closeCamera()
                                hideAndroidButtons(false)
                            }}
                            handleImagePickerResult={handleImagePickerResult}
                        />
                    </Modal>
                </View>
            ) : (
                <View>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    <Text style={[styles.title, { textAlign: 'center' }]}>{languageFile.where_do_you_want}</Text>
                    <View style={styles.iconButtonContainer}>
                        {hasCamera && (
                            <View>
                                <TouchableOpacity style={styles.iconButton} onPress={() => openCamera()}>
                                    <Feather name='camera' size={24} color={theme.colors.colorPrimary} />
                                    <Text style={styles.iconButtonText}>{languageFile.camera.toUpperCase()}</Text>
                                </TouchableOpacity>
                            </View>
                        )}

                        {hasCamera && hasGalery && <View style={styles.dividerVerticalLine}></View>}

                        {hasGalery && (
                            <View>
                                <TouchableOpacity style={styles.iconButton} onPress={() => openGalery()}>
                                    <Feather name='image' size={24} color={theme.colors.colorPrimary} />
                                    <Text style={styles.iconButtonText}>{languageFile.gallery.toUpperCase()}</Text>
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                </View>
            )}
        </>
    )
}
